import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Grid from './Grid/Grid';
import Sidebar from './Sidebar/Sidebar';
import TabGroup from './TabGroup/TabGroup';
import FileManager from './FileManager/FileManager';
import AssetViewer from './AssetViewer/AssetViewer';
import TemplateManager from './TemplateManager/TemplateManager';
import Tab from './Tab/Tab';
import ConnectionStatus from '../ConnectionStatus/ConnectionStatus';
import Tutorial from '../Tutorial/Tutorial';
import T, {Translate} from '../i18n/i18n';
import ErrorBoundary from '../ErrorHandler/ErrorBoundary';
import BugReport from '../BugReport/BugReport';
import BugReportButton from '../BugReport/BugReportButton';
import { getStatus } from '../../services/profile';
import { configActions } from '../../redux/actions';

import ChatBox from '../ChatBox/ChatBox';
import PlayersList from '../PlayersList/PlayersList';
import GridTools from '../GridTools/GridTools';
import Characters from '../Characters/Characters';
import Jukebox from '../Jukebox/Jukebox';
import Assets from '../Assets/Assets';
import CharSheet from './CharSheet/CharSheet';
import QuickSheet from './QuickSheet/QuickSheet';
import TurnOrder from './TurnOrder/TurnOrder';
import Timers from './Timers/Timers';

import { Container, Help } from './Table.styles';
import TableForm from './TableForm/TableForm';

export default () => {

    const routerParams = useParams();

    const [isOpenTemplate, setIsOpenTemplate] = useState(false);
    const isOwner = useSelector(state => state.authState.isOwner);
    const playerId = useSelector(state => state.authState.id);
    const dispatch = useDispatch();

    const renderTabs = () => {
        return [
            <Tab hidden={false} key={1} component={<ErrorBoundary id="chatBox"><ChatBox /></ErrorBoundary>}><T value="tabs.chat" /></Tab>,
            <Tab hidden={false} key={2} component={<ErrorBoundary id="playersList"><PlayersList tableId={routerParams.id} /></ErrorBoundary>}><T value="tabs.players" /></Tab>,
            <Tab hidden={false} key={3} component={<ErrorBoundary id="characters"><Characters tableId={routerParams.id} /></ErrorBoundary>}><T value="tabs.characters" /></Tab>,
            <Tab hidden={false} key={4} component={<ErrorBoundary id="assets"><Assets tableId={routerParams.id} /></ErrorBoundary>}><T value="tabs.assets" /></Tab>,
            <Tab hidden={!isOwner} key={5} component={<ErrorBoundary id="gridTools"><GridTools tableId={routerParams.id} /></ErrorBoundary>}><T value="tabs.scenery" /></Tab>,
            <Tab hidden={false} key={6} component={<ErrorBoundary id="jukebox"><Jukebox tableId={routerParams.id} /></ErrorBoundary>}><T value="tabs.jukebox" /></Tab>
        ];
    }

    const hideTutorial = useMemo(()=>{
        return localStorage.getItem('hide-tutorial-table-'+playerId) || false;
    }, [playerId]);

    const keyCancel = (e) => {
        e.stopPropagation();
    }

    useEffect(() => {
        (async () => {
            await getStatus();
        })();
    }, []);

    useEffect(() => {
        dispatch(configActions.setTableId(routerParams.id));
    }, [routerParams.id]);

    return <Container>
        <ErrorBoundary id="grid"><Grid tableId={routerParams.id}/></ErrorBoundary>
        <ErrorBoundary id="sidebar"><Sidebar onKeyDown={keyCancel} tableId={routerParams.id} /></ErrorBoundary>
        <Help title={Translate('gridtools.gotohelp')} href="/ajuda" target="_blank" />
        <BugReportButton />
        <ErrorBoundary id="TableForm"><TableForm tableId={routerParams.id} onKeyDown={keyCancel} /></ErrorBoundary>
        <ErrorBoundary id="fileManager"><FileManager onKeyDown={keyCancel} /></ErrorBoundary>
        <ErrorBoundary id="templateManager"><TemplateManager onKeyDown={keyCancel} /></ErrorBoundary>
        <ErrorBoundary id="quickSheet"><QuickSheet /></ErrorBoundary>
        <div style={{position:"absolute", left:0, right:430, bottom: 0, height: 100, overflow:"visible"}}>
            <ErrorBoundary id="turnOrder"><TurnOrder tableId={routerParams.id}/></ErrorBoundary>
            <ErrorBoundary id="timers"><Timers tableId={routerParams.id}/></ErrorBoundary>
        </div>
        <ErrorBoundary id="charSheet"><CharSheet onKeyDown={keyCancel} tableId={routerParams.id} /></ErrorBoundary>
        <ErrorBoundary id="assetViewer"><AssetViewer tableId={routerParams.id}/></ErrorBoundary>

        <TabGroup onKeyDown={keyCancel}>
            { renderTabs() }
        </TabGroup>

        <ConnectionStatus />
        <BugReport tableId={routerParams.id} />
        {hideTutorial ? null : <Tutorial start={6} end={10} id="table" translate="tutorial.titletable" />}
    </Container>
};